import styled from 'styled-components';

const GridViewStyles = styled.div`
  .contact-item {
    height: 100%;
  }
`;

export default GridViewStyles;
